<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 财务中心->线下充值申请 -->
    <div class="main2">
      <div class="title">线下充值申请</div>
      <div class="main2">
        <div class="info">
          <div class="item" style="margin-top:15px;">
            <div class="top"><span>*</span>充值金额</div>
            <div class="bottom">
              <input
                v-model="payMoney"
                type="text"
                placeholder="请输入充值金额"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span>*</span>付款账户</div>
            <div class="">
              <el-select
                v-model="useChooseAccountIndex"
                name=""
                id=""
                class="img"
              >
                <el-option
                  v-for="(item, index) of accountList"
                  :key="index"
                  :label="item.accountNumberName"
                  :value="index"
                >
                  {{ item.accountNumberName }}</el-option
                >
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="top"><span>*</span>添加图片附件</div>
            <div class="imgs">
              <div class="item flexStyle1">
                +
                <input type="file" readonly="readonly" @change="upImage" />
              </div>
              <div
                class="item flexStyle1"
                v-for="(item, index) of imgs"
                :key="index"
              >
                <img :src="item" alt="" class="img" />
              </div>
            </div>
          </div>
          <div class="item">
            <div class="top"><span>*</span>备注</div>
            <div class="bottom bottom2">
              <textarea
                v-model="remark"
                name=""
                id=""
                cols="30"
                rows="10"
                class="img"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="buttons">
          <span class="hands item" @click="submitPayBefore">确认充值</span>
        </div>
      </div>
    </div>
    <!-- 财务中心->线下充值申请 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import {
  payAccountInfoRequest,
  upLoadImgRequest,
  lineDownPayApplyRequest,
} from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      token: "", // 1.1.token
      accountList: [], // 1.2.账户列表
      useChooseAccountIndex: 0, // 1.3.用户选择的账户的index
      fileType: {
        // 1.4.可上传图片类型
        accept: "image/gif, image/jpeg, image/png, image/jpg",
      },

      imageEnclosure: "", // 1.5.图片附件
      payMoney: "", // 1.6.充值金额
      remark: "", // 1.7.备注
      imgs: [], // 1.8.图片
    };
  },

  methods: {
    // 2.methods
    getPayAccountInfo() {
      // 2.1.获取付款到账户列表信息
      payAccountInfoRequest().then((res) => {
        if (res) {
          this.accountList = res.data;
        }
      });
    },

    submitPayBefore() {
      // 2.2.确认之前
      if (this.verifacation()) {
        this.submitPay();
      }
    },

    upImage(event) {
      // 2.3.上传图片
      let img = event.target.files[0];
      let type = img.type;
      let size = img.size;

      if (this.fileType.accept.indexOf(type) == -1) {
        this.$message.error("请选择正确图片格式！");
        return false;
      }

      if (size > 5242880) {
        this.$message.error("请选择5M以内的图片！");
        return false;
      }

      let formData = new FormData();
      formData.append("file", img, img.name);
      this.openLoading();

      upLoadImgRequest(formData).then((res) => {
        if (res) {
          this.closeLoading();
          this.imageEnclosure = res.url;
          this.imgs.push(res.url);
        }
      });
    },

    verifacation() {
      // 2.4.校验表单方法
      if (!this.payMoney.trim()) {
        // 校验充值金额
        this.$notify({
          title: "提示",
          message: "请输入充值金额",
        });
        return;
      }

      if (this.imgs.length <= 0) {
        // 校验图片附件
        this.$notify({
          title: "提示",
          message: "请上传图片附件",
        });
        return;
      }

      return true;
    },

    submitPay() {
      // 2.5.确认
      let data = {
        payMoney: this.payMoney,
        imageEnclosure: this.imgs,
        remark: this.remark,
        accountNumberId: this.accountList[this.useChooseAccountIndex]
          .accountNumberId,
        accountNumberName: this.accountList[this.useChooseAccountIndex]
          .accountNumberName,
      };

      lineDownPayApplyRequest(data).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          window.scroll(0, 0);

          this.imageEnclosure = "";
          this.payMoney = "";
          this.remark = "";
          this.imgs = [];
          this.closeLoading();
        }
      });
    },

    openLoading() {
      // 2.6.打开加载遮罩层
      this.loadingInstance = this.$loading.service({
        fullscreen: true,
        lock: true,
      });
    },

    closeLoading() {
      // 2.7.关闭遮罩层
      this.loadingInstance.close();
    },
  },

  mounted() {
    // 3.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getPayAccountInfo(); // 3.4.1.获取付款到账户列表信息
    }
  },
};
</script>

<style scoped lang="scss">
$ui-width: 1350px;
@function px2vw($px) {
  @return $px / $ui-width * 100vw;
}

$mainColor1: #e65a5a;
$mainColor2: #dd3242;
$mainColor3: #ff0000;

/* 1.all-container-style-start */
.all-container {
  border-radius: px2vw(6px);
  overflow: hidden;
  box-sizing: border-box;
  padding: px2vw(2px);
  width: 100%;

  > .main {
    flex: 1;
    border-radius: px2vw(6px);
    overflow: hidden;
    box-sizing: border-box;
    padding: px2vw(2px);

    > div {
      border-radius: px2vw(6px);
      overflow: hidden;
      margin-bottom: px2vw(20px);
      overflow: hidden;
      width: 100%;
      box-sizing: border-box;
      padding: px2vw(10px) px2vw(20px);
    }

    > .title {
      font-size: 15px;
      color: #999;
      font-weight: bold;
    }

    > .main {
      padding-bottom: px2vw(20px);

      > .info {
        font-size: 14px;

        > .item {
          margin-bottom: px2vw(20px);

          > .top {
            margin-bottom: px2vw(10px);
            font-weight: bold;

            > span {
              color: $mainColor3;
              padding-right: px2vw(4px);
            }
          }

          > .bottom {
            width: px2vw(500px);
            max-width: 500px;
            height: px2vw(32px);
            max-height: 40px;
            border: 1px solid #ddd;
            border-radius: px2vw(4px);
            overflow: hidden;
            box-sizing: border-box;
            padding-left: px2vw(10px);
          }

          > .bottom2 {
            height: px2vw(140px);
            padding-left: 0;
          }

          > .imgs {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            > .item {
              width: px2vw(100px);
              height: px2vw(100px);
              max-width: 100px;
              max-height: 100px;
              border-radius: 6px;
              background: #f5f5f5;
              margin: 0 px2vw(10px) px2vw(10px) 0;
              font-size: px2vw(40px);
              color: #ddd;
              overflow: hidden;
              text-align: center;
              position: relative;

              > input {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                opacity: 0;
              }
            }
          }
        }
      }

      > .buttons {
        padding-top: px2vw(40px);

        > .item {
          background-color: $mainColor1;
          color: #fff;
          border-radius: 6px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 px2vw(14px) px2vw(10px) 0;
          padding: 10px 80px;
        }
      }
    }
  }
}
/* 1.all-container-style-start */
</style>
